import {
    Button,
    Circle,
    Flex,
    Modal,
    ModalBody,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalOverlay,
    Text,
    useDisclosure,
} from '@chakra-ui/react';
import { useEffect } from 'react';
import { BrowserView } from 'react-device-detect';
import { FormattedMessage } from 'react-intl';
import { Link as ReactRouterLink } from 'react-router-dom';
import { AuthenticatedComponent } from '../auth/keycloak';
import { BrowserSidebar } from '../component/globalComponents/BrowserSidebar';
import { BrowserTopBar } from '../component/globalComponents/BrowserTopBar';
import { CustomCheckBox } from '../component/globalComponents/CustomCheckBox';
import { MobileViewPage } from '../component/globalComponents/MobileViewPage';
import { CurrencyForPayout } from '../component/profileComponents/CurrencyForPayout';
import { useLocalStorage } from '../hooks/useLocalStorage';
import { DashboardNewsPage } from './DashboardNewsPage';
import { DashboardSessionsPage } from './DashboardSessionsPage';
import { DashboardTransactionsPage } from './DashboardTransactionsPage';
import { DashboardWalletPage } from './DashboardWalletPage';

export const DashboardPage: AuthenticatedComponent = ({ keycloak }) => {
    const [hasPublicInfoPopup, setHasPublicInfoPopup] = useLocalStorage(
        'has_public_info_popup',
        false,
    );
    const { isOpen, onClose, onOpen } = useDisclosure();

    useEffect(() => {
        if (!hasPublicInfoPopup) {
            onOpen();
        }
    }, []);

    const renderModal = () => (
        <Modal closeOnOverlayClick={false} isOpen={isOpen} onClose={onClose} isCentered>
            <ModalOverlay className="dashboard-modal-overlay" />
            <ModalContent className="dashboard-modal-content">
                <ModalHeader className="header">
                    <FormattedMessage
                        id="dashboard.public_info_modal_title"
                        defaultMessage={'Public Information'}
                    />
                </ModalHeader>
                <ModalBody>
                    <Text className="body">
                        <FormattedMessage
                            id="dashboard.public_info_modal_description"
                            defaultMessage={
                                'The data on this page is private, but you can show it to others at your own risk.'
                            }
                        />
                    </Text>
                </ModalBody>
                <ModalFooter className="footer">
                    <Flex className="do_not_display_container">
                        <CustomCheckBox
                            index={0}
                            isChecked={hasPublicInfoPopup}
                            onValueChange={() => {
                                setHasPublicInfoPopup(!hasPublicInfoPopup);
                            }}
                        />
                        <Text>
                            <FormattedMessage
                                id="global.do_not_display"
                                defaultMessage={'Do not display this message again.'}
                            />
                        </Text>
                    </Flex>
                    <Button
                        onClick={() => {
                            onClose();
                        }}
                    >
                        <FormattedMessage id="global.close" defaultMessage={'Close'} />
                    </Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );

    return (
        <>
            {renderModal()}
            <BrowserView className="dashboard-browser-view">
                <BrowserTopBar color="#FFF" isLoading={false}>
                    <Flex className={'browser-view-title dashboard-title-browser'}>
                        <FormattedMessage
                            id="dashboard.title"
                            defaultMessage={'CREATOR DASHBOARD'}
                        />
                    </Flex>
                </BrowserTopBar>

                <Flex className="dashboard-browser-bottom-section">
                    <BrowserSidebar />
                    <Flex className="dashboard-browser-columns browser-content">
                        <Flex className={'browser-section'}>
                            {/* <Text className={'header'}>
                            <FormattedMessage
                                id="dashboard.streamer_standing"
                                defaultMessage={'STREAMER STANDING'}
                            />
                        </Text>
                        <StreamerStandingDisplay keycloak={keycloak} /> */}
                            <Text className={'header'}>WALLET</Text>
                            <DashboardWalletPage keycloak={keycloak} />
                        </Flex>

                        <Flex className={'browser-section'}>
                            <Text className={'header'}>TRANSACTIONS</Text>
                            <DashboardTransactionsPage keycloak={keycloak} />
                        </Flex>

                        <Flex className={'browser-section'}>
                            <Text className={'header'}>
                                <FormattedMessage
                                    id="dashboard.sessions.title"
                                    defaultMessage={'SESSIONS'}
                                />
                            </Text>
                            <DashboardSessionsPage keycloak={keycloak} />
                        </Flex>

                        <Flex className={'browser-section'}>
                            <Text className={'header'}>
                                <FormattedMessage
                                    id="dashboard.news.title"
                                    defaultMessage={'NEWS'}
                                />
                            </Text>
                            <DashboardNewsPage />
                        </Flex>
                    </Flex>
                </Flex>
            </BrowserView>
            <MobileViewPage
                title="CREATOR DASHBOARD"
                titleColor="#FFF"
                titleBackgroundColor="#6867dd"
                isLoading={false}
            >
                <Flex className={'dashboard-container'}>
                    <Flex className={'currency-section'}>
                        <CurrencyForPayout
                            keycloak={keycloak}
                            quantityCallback={() => {}}
                            refreshFlag={false}
                        />
                    </Flex>
                    <Button className={'nav-button'} as={ReactRouterLink} to={`/dashboard/wallet`}>
                        <FormattedMessage
                            id="dashboard.wallet_button"
                            defaultMessage={'My Wallet'}
                        />
                    </Button>
                    <Button
                        className={'nav-button'}
                        as={ReactRouterLink}
                        to={`/dashboard/transactions`}
                    >
                        <FormattedMessage
                            id="dashboard.transaction_button"
                            defaultMessage={'Transaction History'}
                        />
                    </Button>
                    <Flex className={'divider'} />
                    <Button
                        className={'nav-button'}
                        as={ReactRouterLink}
                        to={`/dashboard/sessions`}
                    >
                        <FormattedMessage
                            id="dashboard.session_button"
                            defaultMessage={'Game Play and Sessions'}
                        />
                    </Button>
                    <Flex className={'divider'} />
                    <Button className={'nav-button'} as={ReactRouterLink} to={`/dashboard/news`}>
                        <FormattedMessage
                            id="dashboard.changelog_button"
                            defaultMessage={'News and Changelog'}
                        />
                        <Circle className={'nav-button-badge'} size={'21px'}>
                            <Text>1</Text>
                        </Circle>
                    </Button>
                </Flex>
            </MobileViewPage>
        </>
    );
};
